import type { DateFormattingConfig, Option, UserConfig, UserConfigProps } from './types';

export const DEFAULT_TIMEZONE_OPTION: Option = { label: 'UTC', value: 'UTC' };
export const DEFAULT_DATE_FORMAT_OPTION: Option = {
  label: '14-Mar-25',
  value: 'dd-MMM-yy'
};
export const EMPTY_OPTION: Option = { label: '', value: '' };

const DEFAULT_TIMEZONE = DEFAULT_TIMEZONE_OPTION.value;
const DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT_OPTION.value;

const normalizeOption = ({ label, value }: Option): Option => ({ label, value });

const isUserConfig = (config: UserConfig | DateFormattingConfig): config is UserConfig =>
  typeof config.dateFormat === 'object';

export const createUserConfig = (props: UserConfigProps): UserConfig => ({
  timezone: normalizeOption(props.timezone),
  dateFormat: normalizeOption(props.dateFormat),
  defaultMarket: normalizeOption(props.defaultMarket),
  homepage: normalizeOption(props.homepage),
  chatHistory: props.chatHistory,
  exportVideoExplainerSeen: props.exportVideoExplainerSeen ?? false
});

export const updateUserConfig = (
  userConfig: UserConfig,
  partial: Partial<UserConfigProps>
): UserConfig => createUserConfig({ ...userConfig, ...partial });

export const markUserConfigExplainerVideoSeen = (userConfig: UserConfig): UserConfig =>
  updateUserConfig(userConfig, { exportVideoExplainerSeen: true });

export const resolveUserDateFormattingConfig = (
  config: UserConfig | DateFormattingConfig
): DateFormattingConfig => {
  if (isUserConfig(config)) {
    return {
      dateFormat: config.dateFormat.value || DEFAULT_DATE_FORMAT,
      timezone: config.timezone.value || DEFAULT_TIMEZONE
    };
  }

  return {
    dateFormat: config.dateFormat || DEFAULT_DATE_FORMAT,
    timezone: config.timezone || DEFAULT_TIMEZONE
  };
};

export const createDefaultUserConfig = (): UserConfig =>
  createUserConfig({
    timezone: DEFAULT_TIMEZONE_OPTION,
    dateFormat: DEFAULT_DATE_FORMAT_OPTION,
    defaultMarket: EMPTY_OPTION,
    homepage: EMPTY_OPTION,
    chatHistory: [],
    exportVideoExplainerSeen: false
  });
